// extracted by mini-css-extract-plugin
export default {"game":"DailyAnnouncement_game__BHRhq","gameLogo":"DailyAnnouncement_gameLogo__gDAGs","gameName":"DailyAnnouncement_gameName__FilT4"};